import { AzureStoragePlannerStepProps } from "./AzureStoragePlannerHelpers";
import { Box, Card, CardContent, CircularProgress, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useCreateAzureStorageConsumptionPlan } from "./azure_storage_planner_hooks";
import Grid from "@mui/material/Grid2";
import { useMountEffect } from "../../../common/hooks/hookslib";
import { useTranslation } from "react-i18next";

// ======================
// AzureStoragePlannerGeneratePlanStep
// ======================

export const AzureStoragePlannerGeneratePlanStep: React.FC<AzureStoragePlannerStepProps> = (p) => {
    const { t } = useTranslation("integrations");
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const createConsumptionPlan = useCreateAzureStorageConsumptionPlan();

    useMountEffect(() => {
        createConsumptionPlan.mutate();
    });

    return (
        <Card
            sx={{
                backgroundColor: "black",
            }}
        >
            <CardContent>
                <Grid container spacing={0} alignItems={"center"}>
                    <Grid
                        size={{
                            xs: 12,
                            sm: 1,
                        }}
                    >
                        <Box display={"flex"} justifyContent={"center"} pb={isMobile ? 2 : 0}>
                            <CircularProgress color={"primary"} />
                        </Box>
                    </Grid>
                    <Grid
                        size={{
                            xs: 12,
                            sm: 11,
                        }}
                    >
                        <Typography variant={"h6"}>{t("azurePlanner.generating.title")}</Typography>
                        <Typography>{t("azurePlanner.generating.message")}</Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};
